import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { RecommendItems } from '../services/activities';

const RecommendWrapper = styled.div`
  height: 240px;
  position: relative;
  background: white;
  overflow: hidden;
  display: flex;
  flex-direction: column-reverse;
`;

const Recommendback1 = styled.div`
  width: 120%;
  height: 220px;
  transform: rotate(2.272deg) translateX(-5px);
  background: rgba(44, 56, 146, 0.43);
`;

const Recommendback2 = styled.div`
  height: 210px;
  transform: rotate(-2.272deg) translateY(10px);
  background: #2c3892;
`;

const Title = styled.div`
  margin: 0;
  padding: 15px 20px;
  text-align: left;
  color: white;
  font-weight: 600;
`;

const RecommendList = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 25px;
  padding-right: 20%;
  overflow-x: auto;
  white-space: nowrap;
  transition: transform 0.3s ease-in-out;
`;

const ItemDiscount = styled.div`
  position: absolute;
  top: 4px;
  left: 4px;
  background: #ED4D1B;
  color: white;
  font-size: 12px;
  font-weight: bold;
  padding: 3px 10px;
  border-radius: 12px 0 12px 0;
`;

const RecommendItem = styled.div`
  position: relative;
  width: 130px;
  height: 130px;
  display: flex;
  flex-direction: column;
  background: white;
  margin: 5px 10px 10px 0;
  border-radius: 12px;
  border: 1px solid #B0B0B0;
  flex-shrink: 0;
  align-items: center;
  padding: 2px;
`;

const ItemImage = styled.img`
  width: 125px;
  height: 70px;
  border-radius: 12px;
  object-fit: cover;
  margin: 2px auto;
`;

const ItemBottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  height: 90%;
  width: 90%;
  margin: 2px;
`;

const ItemTitle = styled.div`
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
`;

const ItemPrice = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: bolder;
  text-align: right;
  color: #ED4D1B;
  padding-right: 5px;
  border-radius: 8px;
`;


function Recommend() {
  const [recommendItems, setRecommendItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRecommendItems = async () => {
      try {
        setLoading(true);
        const data = await RecommendItems();
        setRecommendItems(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
  
    fetchRecommendItems();
  }, []);

  return (
    <RecommendWrapper>
      <Recommendback1>
        <Recommendback2>
          <Title>✨ Trending Tickets</Title>
          {loading ? (
            <p style={{ color: "white", textAlign: "center", fontSize: "16px" }}>Loading...</p>
          ) : error ? (
            <p style={{ color: "red", textAlign: "center" }}>Error: {error}</p>
          ) : (
            <RecommendList>
              {recommendItems.map(item => (
                <RecommendItem key={item.id} onClick={() => navigate(`/items/${item.id}`)}>
                  {item.discountRate > 0 && (
                    <ItemDiscount>-{parseFloat(item.discountRate.toFixed(2))}%</ItemDiscount>
                  )}
                  <ItemImage src={item.image.length > 0 ? item.image[0] : "/assets/tempAct.jpg"}
                   alt={item.name} 
                  />
                  <ItemBottom>
                    <ItemTitle>{item.name}</ItemTitle>
                    <ItemPrice>${item.lowestPrice}~</ItemPrice>
                  </ItemBottom>
                </RecommendItem>
              ))}
            </RecommendList>
          )}
        </Recommendback2>
      </Recommendback1>
    </RecommendWrapper>
  );
}

export default Recommend;